<template>
<div class="card-profiles">

    <h2>People</h2>

    <ul class="card-profile-list">
        <li v-for="item in profiles"
            :key="item.id">
            <CardProfile v-bind="item" />
        </li>
    </ul>

</div>
</template>


<script>
import {
    mapState
} from 'vuex'
import CardProfile from '@/components/CardProfile.vue'

export default {
    name: 'CardProfileList',
    components: {
        CardProfile
    },
    computed: mapState({
        profiles: function(state) {
            return state.data.profiles
        }
    }),
}
</script>


<style scoped lang="scss">
@import "../scss/globals.scss";

.card-profiles {
    @extend %page-margin-1;
}

h2 {
    font-size: $font-size-sm;
    font-family: $font-expanded;

    margin-bottom: $margin1-2;
    @media screen and (min-width: 377px) {
        font-size: $font-size-m;
    }
}

ul {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    column-gap: $margin1-4;

    padding: 0 0 $margin1-1;
    margin: 0;
    @media screen and (min-width: 400px) {
        grid-template-columns: repeat(2, 1fr);
        column-gap: $margin1-4;
    }
    @media screen and (min-width: 769px) {
        grid-template-columns: repeat(3, 1fr);
        column-gap: $margin1-2;
    }
    @media screen and (min-width: 1400px) {
        grid-template-columns: repeat(4, 1fr);
        column-gap: $margin1-1;
    }

    li {
        list-style: none;
        width: 100%;
        margin-bottom: $font-size-s;
        box-sizing: border-box;

        @media screen and (min-width: 400px) {
            &:nth-child(2n) {
                .card-profile {
                    transition-delay: 0.2s;
                }
            }
        }
        @media screen and (min-width: 769px) {
            &:nth-child(3n-2) {
                .card-profile {
                    transition-delay: 0s;
                }
            }
            &:nth-child(3n-1) {
                .card-profile {
                    transition-delay: 0.2s;
                }
            }
            &:nth-child(3n) {
                .card-profile {
                    transition-delay: 0.4s;
                }
            }
        }
        @media screen and (min-width: 1400px) {
            &:nth-child(4n-3) {
                .card-profile {
                    transition-delay: 0s;
                }
            }
            &:nth-child(4n-2) {
                .card-profile {
                    transition-delay: 0.2s;
                }
            }
            &:nth-child(4n-1) {
                .card-profile {
                    transition-delay: 0.4s;
                }
            }
            &:nth-child(4n) {
                .card-profile {
                    transition-delay: 0.6s;
                }
            }
        }

    }
}
</style>
